export function initFileInput(targetEl) {
  const target = targetEl || document;
  target.querySelectorAll('.file-input').forEach((elm) => {
    const input = elm.querySelector('input[type="file"]');
    const label = elm.querySelector('.file-name');
    if (input && label) {
      input.addEventListener('change', (e) => {
        const filename = e.target.files[0].name || '';
        label.textContent = filename;
      });
    }
  });
}
